module.exports = __webpack_public_path__ + "img/axle_conf_4.3fc5ebcf.jpg";